/* eslint-disable react/prop-types */
import { useContext, useEffect, useRef, useState } from 'react';
import LeadGenerationContext from '../../context/LeadGenerationContext';

function LoginPageInternal(props) {
  const elRef = useRef(null);

  const { wcData } = useContext(LeadGenerationContext);
  const { productName, language, productType, accessToken, otpToken } = wcData.salesData || {};

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    // Keep your candidate order
    const candidates = [
      '/wc-ExpressFlowInitializer.js',
      '/dist/wc-ExpressFlowInitializer.js',
      '/static/js/wc-ExpressFlowInitializer.js',
      'dist/wc-ExpressFlowInitializer.js',
    ];

    // NEW: inject by URL (no blob)
    function injectScriptSrc(url) {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = url;
        s.defer = true; // adjust if it must execute ASAP
        s.onload = () => resolve();
        s.onerror = (e) => reject(e);
        document.head.appendChild(s);
      });
    }

    async function tryLoad() {
      try {
        // Fetch all candidates to figure out which one is JS (not HTML fallback)
        const fetchPromises = candidates.map((url) =>
          fetch(url, { cache: 'no-store' })
            .then((res) => ({ url, res }))
            .catch((err) => ({ url, err }))
        );

        const settled = await Promise.all(fetchPromises);

        // For successful responses, read text to check if it's not HTML
        const textPromises = settled.map((item) => {
          if (item.res && item.res.ok) {
            return item.res.text().then((text) => ({ url: item.url, text }));
          }
          return Promise.resolve({ url: item.url, text: null });
        });

        const texts = await Promise.all(textPromises);

        // Find first non-HTML JS candidate
        let foundUrl = null;
        for (let i = 0; i < candidates.length && !cancelled; i += 1) {
          const url = candidates[i];
          const t = texts.find((x) => x.url === url);
          if (t && t.text) {
            const preview = t.text.trim().slice(0, 20);
            if (preview.startsWith('<')) {
              console.warn('Login bundle at', url, 'looks like HTML. Preview:', preview);
            } else {
              foundUrl = url;
              break;
            }
          }
        }

        if (foundUrl) {
          // IMPORTANT: load by URL (no blob)
          await injectScriptSrc(foundUrl);
          if (!cancelled) {
            try {
              await customElements.whenDefined('sales-express-wc');
              setLoaded(true);
            } catch (e) {
              setError(e);
            }
          }
          return;
        }

        if (!cancelled) {
          setError(new Error('Could not find a valid sales-express-wc bundle in candidates'));
        }
      } catch (err) {
        if (!cancelled) setError(err);
      }
    }

    tryLoad();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (loaded && elRef.current && typeof elRef.current.renderWebComponent === 'function') {
      try {
        elRef.current.renderWebComponent({
          custIdToken: wcData.otpToken,
          devicePlatform: '',
          lang: wcData.language,
          source: 'OMB',
          wcFlow: true,
          salesData: {
            location: 'PR',
            productName: wcData.productName,
            productType: wcData.productType,
            offers: false,
            accessToken,
          },
          env: process.env.REACT_APP_ENVIRONMENT,
        });
      } catch (e) {
        console.error('renderWebComponent call failed', e);
      }
    }
  }, [loaded, accessToken, otpToken, productName, productType, language, wcData]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {error && (
        <div style={{ padding: 16 }}>
          <strong>Webcomponent load error:</strong>
          <div>{String(error)}</div>
        </div>
      )}
      <div style={{ width: '100%', height: '100%' }}>
        <sales-express-wc
          ref={elRef}
          productName={wcData.productName}
          productType={wcData.productType}
        />
      </div>
    </div>
  );
}

export default LoginPageInternal;
